import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import store from '@/store';
function getStrucName(code) {
  var res = store.state.cpscc.strucList.find(function (item) {
    return item.l01StrucCode === code;
  });
  if (res) {
    return res.l01Name;
  }
  return code;
}
function getHttpHeaderDisposition(data, name) {
  var headers = data.headers;
  var content = '';
  if (headers) {
    content = headers['content-disposition'];
  }
  var fileExt = content.match(/\.([0-9a-z]+)(?:[\?#]|$)/gi);
  var n;
  if (name) {
    if (name.indexOf('.') !== -1) {
      n = name;
    } else {
      if (fileExt && fileExt[0]) {
        n = "".concat(name).concat(fileExt[0]);
      }
    }
  }
  createObjectURL(data.data, n);
}
function createObjectURL(data, name) {
  var downloadUrl = URL.createObjectURL(data);
  var a = document.createElement('a');
  // a.href = downloadUrl;
  a.target = '_blank';
  if (name) {
    a.download = name;
  }
  document.body.appendChild(a);
  a.addEventListener('click', function (e) {
    a.href = downloadUrl;
  });
  var e = document.createEvent('MouseEvents');
  e.initEvent('click', false, false);
  a.dispatchEvent(e);
  // document.body.removeChild(a);
  window.URL.revokeObjectURL(downloadUrl);
}
function transformFilterComponentDataV2(params, type) {
  var data = params;
  var list = [];
  var str = '';
  for (var key in data) {
    if (data.hasOwnProperty(key) && data[key] !== undefined && data[key] !== '') {
      var symbol = data[key].Symbol;
      if (symbol) {
        if (symbol === 'contains') {
          list.push("".concat(key, ".contains(\"").concat(data[key].value, "\")"));
        } else {
          if (data[key].inputType === 'number') {
            list.push("".concat(key, " ").concat(symbol, " ").concat(data[key].value));
          } else {
            list.push("".concat(key, " ").concat(symbol, " \"").concat(data[key].value, "\""));
          }
        }
      }
    }
  }
  if (list.length > 0) {
    str = list.join(" ".concat(type, " "));
  }
  return str;
}
function transformInputCodes(codes) {
  if (codes) {
    codes = codes.trim();
    if (/^H/.test(codes)) {
      return codes.split(/H(.{12})/).filter(function (item) {
        return item;
      });
    } else if (codes.indexOf(',') !== -1) {
      return codes.split(',').filter(function (item) {
        return item;
      });
    } else if (codes.length > 12) {
      return codes.split(/(.{12})/).filter(function (item) {
        return item;
      });
    } else {
      return [codes];
    }
  }
  return [];
}
function getBackConfirmExplain(code, msg) {
  var obj = {
    code: '',
    msg: ''
  };
  if (code.indexOf(':') === 1) {
    var r = code.split(':');
    obj.code = r[0];
    obj.msg = r[1];
  } else {
    if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(code)) {
      var sub = store.state.cpscc.backConfirmExplainList.find(function (item) {
        return item.value === code;
      });
      if (sub) {
        obj.code = sub.value;
        obj.msg = sub.label;
      }
    } else {
      var text = code;
      obj.code = '0';
      obj.msg = text;
    }
  }
  return {
    code: obj.code,
    msg: obj.code === '0' && msg ? msg : obj.msg
  };
}
export { getStrucName, createObjectURL, transformFilterComponentDataV2, getHttpHeaderDisposition, transformInputCodes, getBackConfirmExplain };